var FavoritosEnum = /* @__PURE__ */ ((FavoritosEnum2) => {
  FavoritosEnum2["FAVORITOS_LOCAL_CONTAINER"] = "local-container";
  FavoritosEnum2["FAVORITOS_BRANCH_CONTAINER"] = "branch-container";
  return FavoritosEnum2;
})(FavoritosEnum || {});
export {
  FavoritosEnum
};
